import { createAction, props } from '@ngrx/store';

export const enum NavigateActionTypes {
  navigateToPage = '[navigate] NAVIGATE_TO_PAGE',
  navigateToPreviousPathStep = '[navigate] NAVIGATE_TO_PREVIOUS_PATH_STEP',
  navigateToNewCulture = '[navigate] NAVIGATE_TO_NEW_CULTURE',
}

export const navigateToPage = createAction(
  NavigateActionTypes.navigateToPage,
  props<{ flow: string; page: string }>(),
);

export const navigateToPreviousPathStep = createAction(
  NavigateActionTypes.navigateToPreviousPathStep,
);

export const navigateToNewCulture = createAction(
  NavigateActionTypes.navigateToNewCulture,
  props<{ newCulture: string; }>(),
);
